import React from "react"

import { type Theme, css } from "@emotion/react"
import type { Interpolation } from "@emotion/serialize"

import { FRONT_GENERAL_CONFIG } from "../config/general.config"
import { NIRVANA_COLORS, NIRVANA_THEME } from "../config/theme.config"

import closeIcon from "@front-shared/assets/images/icons/close-dark.svg"

import logoImg from "../assets/images/logo.svg"

export const CheckoutPopupWrapperElement: React.FunctionComponent<
    ICheckoutPopupWrapperProps
> = props => {
    return props.isActive ? (
        <div
            className={`
                relative
                ${props.className}
            `}
        >
            <div
                css={[
                    styles.popup,
                    !props.popupWidthClassName
                        ? styles.popupDefaultWidth
                        : undefined,
                    !props.popupHeightClassName
                        ? styles.popupDefaultHeight
                        : undefined,
                    props.popupCss,
                ]}
                className={`${props.popupWidthClassName} ${props.popupHeightClassName}`}
            >
                {props.onCancel && (
                    <div css={styles.closeIcon} onClick={props.onCancel}>
                        <img src={closeIcon} alt="Close" title="Close" />
                    </div>
                )}

                <div
                    className="flex-1 flex flex-col"
                    css={[styles.leftContent]}
                >
                    {props.withLogo && (
                        <div css={styles.logoWrapper}>
                            <a
                                href={FRONT_GENERAL_CONFIG.mainWebsiteUrl}
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                <img
                                    css={styles.logo}
                                    src={logoImg}
                                    alt="Nirvana Mental Health"
                                    title="Nirvana Mental Health"
                                />
                            </a>
                        </div>
                    )}

                    <div
                        css={[
                            styles.contentInner,
                            !props.withLogo
                                ? styles.contentInnerTopMargin
                                : undefined,
                        ]}
                        className={props.leftContentClassName}
                    >
                        {props.leftContent}
                    </div>
                </div>

                <div
                    className="shadow-9 flex-1 flex flex-col"
                    css={[styles.rightContent]}
                >
                    <div
                        css={[
                            styles.contentInner,
                            styles.contentInnerTopMargin,
                        ]}
                        className={props.rightContentClassName}
                    >
                        <div
                            className="flex-1 flex flex-col"
                            css={[styles.rightContent]}
                        >
                            {props.rightContent}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : null
}

const styles = {
    popup: css({
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 100,
        backgroundColor: NIRVANA_COLORS.brand.offWhite,
        display: "flex",

        [NIRVANA_THEME.mediaQueries.md]: {
            display: "block",
            overflowY: "auto",
        },
    }),
    popupDefaultWidth: css({
        width: "100vw",
    }),
    popupDefaultHeight: css({
        height: "100vh",
    }),
    logoWrapper: css({
        paddingTop: 40,
        paddingLeft: 40,
        paddingBottom: 60,

        [NIRVANA_THEME.mediaQueries.md]: {
            paddingRight: 16,
            paddingLeft: 16,
        },
    }),
    logo: css({
        [NIRVANA_THEME.mediaQueries.md]: {
            margin: "0 auto",
        },
    }),
    leftContent: css({}),
    rightContent: css({
        [NIRVANA_THEME.mediaQueries.md]: {
            boxShadow: "none",
        },
    }),
    contentInner: css({
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        paddingRight: 40,
        paddingLeft: 40,
        paddingBottom: 80,

        [NIRVANA_THEME.mediaQueries.md]: {
            paddingRight: 16,
            paddingLeft: 16,
            paddingBottom: 16,
        },
    }),
    contentInnerTopMargin: css({
        marginTop: 133,

        [NIRVANA_THEME.mediaQueries.md]: {
            marginTop: 32,
        },
    }),
    closeIcon: css({
        position: "absolute",
        right: 22,
        top: 22,
        zIndex: 51,
        padding: 10,
        cursor: "pointer",
    }),
}

interface ICheckoutPopupWrapperProps {
    className?: string
    isActive: boolean
    withLogo?: boolean
    popupCss?: Interpolation<Theme>
    popupWidthClassName?: string
    popupHeightClassName?: string
    leftContent: React.JSX.Element
    leftContentClassName?: string
    rightContent: React.JSX.Element
    rightContentClassName?: string
    onCancel?: () => void
}
